/* eslint-disable import/no-cycle, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call */
import { Checkbox, HStack, Icon, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { MdInfoOutline } from 'react-icons/md';
import { InfoHint } from '../../../../../common/Tooltip/Tooltip';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';

export const QuestionRequireResponse = React.memo(function QuestionRequireResponse({ elementId }: { elementId: string }) {
  const path = `shouldReaskOnReapply`;
  const { t } = useTranslation('questionnaireTemplate');
  const valueSelector = React.useCallback((state) => state.getElementValue(elementId, path), [elementId, path]);
  const value = QuestionnaireTemplateStore.useStoreState(valueSelector);
  const updateValue = QuestionnaireTemplateStore.useStoreActions((actions) => actions.updateElementValue);

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      updateValue({ id: elementId, path, value: e.target.checked });
    },
    [elementId, path, updateValue],
  );
  return (
    <HStack py={4}>
      <Checkbox onChange={handleChange} isChecked={value}>
        <Text fontSize="sm">{t('formBuilder.canvas.element.requireResponse.label')}</Text>
      </Checkbox>
      <InfoHint label={t('formBuilder.canvas.element.requireResponse.info')}>
        <Icon as={MdInfoOutline} color="#00000040" boxSize={4} />
      </InfoHint>
    </HStack>
  );
});
